import { useTranslation } from "react-i18next";
import { Box, Divider, IconButton, Modal, Typography } from "@mui/material";

import { FullScreenPostProps } from "../../types/components/props.type";
import { usePostFormatter } from "../../hooks/usePostFormatter";
import { FullScreenCloseButtonIcon } from "../../assets/icons/create-feed";

import PostCardHeader from "../Posts/PostCardHeader";
import PostActions from "../Posts/PostActions";
import PostDescriptionAndDetails from "../Posts/PostContent/BasicPostCard/BasicPostCard/PostDescriptionAndDetails";

import FullScreenPostModalMediaSlider from "./FullScreenPostModalMediaSlider";
import PostComments from "../Posts/PostComments";

const FullScreenPostModal = ({ open, closeModal, post }: FullScreenPostProps) => {
  const { t } = useTranslation("feed", { keyPrefix: "fullScreenPost" });

  const { description, tags, id } = post;

  const { authorFullName, postMedia } = usePostFormatter(post);

  return (
    <Modal open={open} onClose={closeModal}>
      <Box
        sx={{
          width: { xs: "95%", md: "calc(100% - 128px)" },
          flexDirection: { xs: "column", lg: "row" },
          height: "calc(100% - 100px)",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "#FFF",
          borderRadius: "12px ",
          overflow: "auto",
          display: "flex",
        }}
      >
        <FullScreenPostModalMediaSlider media={postMedia} />
        <Box
          sx={{
            width: { xs: "100%", lg: "480px" },
            display: "flex",
            flexDirection: "column",
            maxHeight: "100%",
            overflow: "auto",
          }}
        >
          <IconButton
            sx={{
              position: "absolute",
              top: "12px",
              right: "12px",
              cursor: "pointer",
            }}
            onClick={closeModal}
          >
            <FullScreenCloseButtonIcon />
          </IconButton>
          <Typography
            variant="h4ExtraBold"
            sx={{
              color: "var(--colors-text-text-primary-900, #101828)",
              textAlign: "center",
              fontFamily: "Montserrat",
              fontSize: "18px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "28px",
              padding: "20px 0",
            }}
          >
            {t("header", { name: authorFullName })}
          </Typography>
          <Divider />
          <Box sx={{ display: "flex", flexDirection: "column", gap: "16px", flexGrow: 1, padding: "0 16px 16px" }}>
            <PostCardHeader post={post} isSharedPost={true} />
            <PostDescriptionAndDetails description={description} tags={tags} />
            <Divider />
            <PostActions post={post} handleOnClickCommentsButton={() => {}} />
            <PostComments postId={post.id} />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default FullScreenPostModal;
